import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b3a4132"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(주)위즈돔    대표이사 : 한상우", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "주소 : (13506) 경기도 성남시 분당구 야탑로 95, 8층", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "사업자등록번호 : 214-88-49124", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "통신판매업신고번호 : 제 2010-경기성남-0535호", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 홈페이지 : "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://wizdome.co.kr" }, " wizdome.co.kr ")
], -1 /* HOISTED */))
const _hoisted_7 = {
  class: "terms-nav",
  "aria-label": "약관 및 정책"
}
const _hoisted_8 = {
  class: "terms-list",
  role: "list"
}
const _hoisted_9 = ["onClick", "aria-label"]
const _hoisted_10 = {
  key: 0,
  class: "divider",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("address", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("p", null, "대표번호 : " + _toDisplayString($setup.csCenterPhone) + " 고객센터 : info@wizdome.co.kr", 1 /* TEXT */),
      _hoisted_6
    ]),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.termsList, (termsInfo, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: termsInfo.code,
            role: "listitem"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["terms-button", { bold: termsInfo.code === $setup.TermsTypeCode.PERSON_FULL }]),
              onClick: ($event: any) => (_ctx.$emit('onClickTerms', termsInfo.code)),
              "aria-label": termsInfo.title
            }, _toDisplayString(termsInfo.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_9),
            (index < $props.termsList.length - 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " I "))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}